const Number = ({ number }) => {
    return (
        <div className="special-number">
            <span>{number}</span>
        </div>
    );
};
export default Number;
